(() => {
  if (window.vetenaColorSelectionLoaded) return;
  window.vetenaColorSelectionLoaded = true;

  const requiredColorSelector = '[data-vetena-required-color]';
  const buyNowSelector = '[data-vetena-buy-now]';

  const getProductInfo = (element) => element?.closest('product-info');

  const getProductForm = (productInfo) =>
    productInfo?.querySelector('product-form[data-vetena-require-color-choice]');

  const getVariantInput = (productInfo) =>
    getProductForm(productInfo)?.querySelector('input.product-variant-id[name="id"]');

  const getAddButton = (productInfo) =>
    getProductForm(productInfo)?.querySelector('button[name="add"]');

  const getBuyNowButton = (productInfo) => productInfo?.querySelector(buyNowSelector);

  const getDynamicCheckout = (productInfo) => productInfo?.querySelector('.shopify-payment-button');

  const requiresColorChoice = (productInfo) =>
    getProductForm(productInfo)?.dataset.vetenaRequireColorChoice === 'true';

  const isColorConfirmed = (productInfo) =>
    !requiresColorChoice(productInfo) || productInfo?.dataset.vetenaColorConfirmed === 'true';

  function prepareColorControls(productInfo, resetSelection) {
    productInfo.querySelectorAll(requiredColorSelector).forEach((container) => {
      const select = container.querySelector('select');
      const placeholder = select?.querySelector('[data-vetena-color-placeholder]');

      if (select && placeholder) {
        select.prepend(placeholder);

        if (resetSelection) {
          Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
          placeholder.selected = true;
          placeholder.setAttribute('selected', 'selected');
        }
      }

      if (resetSelection) {
        container.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');
        });

        const dropdownSwatch = container.querySelector('[data-selected-value]');
        if (dropdownSwatch) dropdownSwatch.hidden = true;
      }
    });
  }

  function disablePurchase(productInfo) {
    const addButton = getAddButton(productInfo);
    const buyNowButton = getBuyNowButton(productInfo);
    const dynamicCheckout = getDynamicCheckout(productInfo);

    if (addButton) addButton.disabled = true;
    if (buyNowButton) buyNowButton.disabled = true;
    if (dynamicCheckout) dynamicCheckout.hidden = true;
  }

  function restoreChosenColor(productInfo) {
    const optionValueId = productInfo.dataset.vetenaColorOptionValueId;
    const optionValue = productInfo.dataset.vetenaColorOptionValue;

    productInfo.querySelectorAll(requiredColorSelector).forEach((container) => {
      const select = container.querySelector('select');

      if (select) {
        const matchingOption = Array.from(select.options).find(
          (option) =>
            (optionValueId && option.dataset.optionValueId === optionValueId) ||
            (!optionValueId && option.value === optionValue)
        );

        if (matchingOption) {
          Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
          matchingOption.selected = true;
          matchingOption.setAttribute('selected', 'selected');
        }
      }

      const matchingRadio = Array.from(container.querySelectorAll('input[type="radio"]')).find(
        (input) =>
          (optionValueId && input.dataset.optionValueId === optionValueId) ||
          (!optionValueId && input.value === optionValue)
      );

      if (matchingRadio) matchingRadio.checked = true;

      const dropdownSwatch = container.querySelector('[data-selected-value]');
      if (dropdownSwatch) dropdownSwatch.hidden = false;
    });
  }

  function syncPurchaseState(productInfo) {
    if (!productInfo || !isColorConfirmed(productInfo)) {
      if (productInfo) disablePurchase(productInfo);
      return;
    }

    restoreChosenColor(productInfo);

    const variantInput = getVariantInput(productInfo);
    const addButton = getAddButton(productInfo);
    const buyNowButton = getBuyNowButton(productInfo);
    const dynamicCheckout = getDynamicCheckout(productInfo);
    const variantIsPurchasable = Boolean(variantInput?.value) && !addButton?.disabled;

    if (buyNowButton) buyNowButton.disabled = !variantIsPurchasable;
    if (dynamicCheckout) dynamicCheckout.hidden = !variantIsPurchasable;
  }

  function initializeProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.vetenaColorSelectionInitialized === 'true') return;

    const productForm = getProductForm(productInfo);
    if (!productForm) return;

    productInfo.dataset.vetenaColorSelectionInitialized = 'true';
    productInfo.dataset.vetenaColorConfirmed = productForm.dataset.vetenaColorConfirmed;

    const resetSelection = requiresColorChoice(productInfo) && !isColorConfirmed(productInfo);
    prepareColorControls(productInfo, resetSelection);

    if (resetSelection) {
      const variantInput = getVariantInput(productInfo);
      const addButtonText = getAddButton(productInfo)?.querySelector('span');

      if (variantInput) variantInput.value = '';
      if (addButtonText) addButtonText.textContent = 'Elige un color';
      disablePurchase(productInfo);
    } else {
      syncPurchaseState(productInfo);
    }
  }

  function initializeWithin(root = document) {
    if (root.matches?.('product-info')) initializeProductInfo(root);
    root.querySelectorAll?.('product-info').forEach(initializeProductInfo);
  }

  document.addEventListener('change', (event) => {
    const colorContainer = event.target.closest?.(requiredColorSelector);

    if (colorContainer) {
      const productInfo = getProductInfo(colorContainer);
      const selectedOption =
        event.target.tagName === 'SELECT' ? event.target.selectedOptions[0] : event.target;

      if (!productInfo || !selectedOption || selectedOption.hasAttribute('data-vetena-color-placeholder')) return;

      productInfo.dataset.vetenaColorConfirmed = 'true';
      productInfo.dataset.vetenaColorOptionValueId = selectedOption.dataset.optionValueId || '';
      productInfo.dataset.vetenaColorOptionValue = selectedOption.value || '';

      const productForm = getProductForm(productInfo);
      if (productForm) productForm.dataset.vetenaColorConfirmed = 'true';

      disablePurchase(productInfo);
    }

    if (event.target.matches?.('input.product-variant-id[name="id"]')) {
      const productInfo = getProductInfo(event.target);
      queueMicrotask(() => syncPurchaseState(productInfo));
    }
  });

  document.addEventListener('click', async (event) => {
    const buyNowButton = event.target.closest?.(buyNowSelector);
    if (!buyNowButton || buyNowButton.disabled) return;

    const productInfo = getProductInfo(buyNowButton);
    const variantInput = getVariantInput(productInfo);
    const variantId = variantInput?.value;

    if (!variantId || !isColorConfirmed(productInfo)) {
      disablePurchase(productInfo);
      return;
    }

    const rootUrl = window.Shopify?.routes?.root || '/';
    buyNowButton.disabled = true;
    buyNowButton.setAttribute('aria-busy', 'true');

    try {
      const clearResponse = await fetch(`${rootUrl}cart/clear.js`, { method: 'POST' });
      if (!clearResponse.ok) throw new Error('No se pudo vaciar el carrito.');

      const addResponse = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!addResponse.ok) throw new Error('No se pudo añadir la variante seleccionada.');
      window.location.assign(`${rootUrl}checkout`);
    } catch (error) {
      console.error('[Vetena] Error en Comprar ahora:', error);
      buyNowButton.removeAttribute('aria-busy');
      syncPurchaseState(productInfo);
    }
  });

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }
})();

/* === VeteNa: filtra la galería por color seleccionado === */
(() => {
  if (window.vetenaColorMediaFilterLoaded) return;
  window.vetenaColorMediaFilterLoaded = true;

  const colorContainerSelector = '[data-vetena-required-color]';
  const slideSelector = '.product__media-item[data-media-id], .thumbnail-list__item[data-target]';

  const getProductInfo = (el) => el?.closest?.('product-info');

  function getColorMap(productInfo) {
    if (productInfo._vetenaMediaColorMap) return productInfo._vetenaMediaColorMap;
    let map = {};
    const script = productInfo.querySelector('[data-vetena-media-color-map]');
    if (script) {
      try { map = JSON.parse(script.textContent); } catch (e) { map = {}; }
    }
    productInfo._vetenaMediaColorMap = map;
    return map;
  }

  function getSelectedColor(productInfo) {
    const container = productInfo.querySelector(colorContainerSelector);
    if (!container) return null;
    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked) return (checked.value || '').trim();
    const select = container.querySelector('select');
    if (select) {
      const opt = select.selectedOptions && select.selectedOptions[0];
      if (opt && opt.hasAttribute('data-vetena-color-placeholder')) return null;
      return (select.value || '').trim();
    }
    return null;
  }

  const mediaIdOf = (el) => (el.dataset.mediaId || el.dataset.target || '').split('-').pop();

  function setSlide(slide, show) {
    slide.hidden = !show;
    slide.style.display = show ? '' : 'none';
  }

  function applyFilter(productInfo) {
    const map = getColorMap(productInfo);
    if (!map || Object.keys(map).length === 0) return;
    const selectedColor = getSelectedColor(productInfo);
    productInfo.querySelectorAll(slideSelector).forEach((slide) => {
      const owner = map[mediaIdOf(slide)];
      const isColorPhoto = owner !== undefined;
      const show = !isColorPhoto || !selectedColor || String(owner).trim() === selectedColor;
      setSlide(slide, show);
    });
  }

  function resetFilter(productInfo) {
    productInfo.querySelectorAll(slideSelector).forEach((slide) => setSlide(slide, true));
  }

  /* Texto de ayuda bajo los colores: avisa de que al elegir color se cambian las fotos */
  function addColorHint(productInfo) {
    const container = productInfo.querySelector(colorContainerSelector);
    if (!container || container.querySelector('.vt-color-hint')) return;
    if (Object.keys(getColorMap(productInfo)).length === 0) return;
    const hint = document.createElement('p');
    hint.className = 'vt-color-hint';
    hint.textContent = 'Toca un color para ver sus fotos';
    container.appendChild(hint);
  }

  /* Si Dawn cambia las fotos al elegir variante, se vuelve a filtrar */
  function watchGallery(productInfo) {
    const list = productInfo.querySelector('.product__media-list');
    if (!list || list._vetenaObserver) return;
    let timer;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (productInfo._vetenaColorChosen) applyFilter(productInfo);
      }, 60);
    });
    observer.observe(list, { childList: true });
    list._vetenaObserver = observer;
  }

  /* Dawn vuelve a pintar el selector al cambiar de color: se reinserta el aviso */
  function watchPicker(productInfo) {
    if (productInfo._vetenaPickerObserver) return;
    let timer;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => addColorHint(productInfo), 80);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
    productInfo._vetenaPickerObserver = observer;
  }

  function initFilter(productInfo) {
    if (!productInfo || productInfo._vetenaFilterReady) return;
    productInfo._vetenaFilterReady = true;
    addColorHint(productInfo);
    watchGallery(productInfo);
    watchPicker(productInfo);
    if (getSelectedColor(productInfo)) {
      productInfo._vetenaColorChosen = true;
      applyFilter(productInfo);
    }
  }

  function initAll(root = document) {
    if (root.matches?.('product-info')) initFilter(root);
    root.querySelectorAll?.('product-info').forEach(initFilter);
  }

  document.addEventListener('change', (event) => {
    const productInfo = getProductInfo(event.target);
    if (!productInfo) return;
    if (event.target.closest?.(colorContainerSelector)) {
      productInfo._vetenaColorChosen = true;
      const list = productInfo.querySelector('.product__media-list');
      if (list && list.scrollTo) list.scrollTo({ left: 0 });
    }
    if (!productInfo._vetenaColorChosen) return;
    applyFilter(productInfo);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const productInfo = getProductInfo(event.target) || event.target.querySelector?.('product-info');
    if (!productInfo) return;
    productInfo._vetenaMediaColorMap = null;
    productInfo._vetenaColorChosen = false;
    productInfo._vetenaFilterReady = false;
    resetFilter(productInfo);
    initFilter(productInfo);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
})();
